/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sales': {
    width: 173,
    height: 173,
    viewBox: '0 0 173 173',
    data: '<defs/><path pid="0" id="sales" class="cls-1" d="M1283 734.292h-14.78a72.212 72.212 0 0 0-64.51-64.509V655h-14.42v14.783a72.212 72.212 0 0 0-64.51 64.509H1110v14.416h14.78a72.209 72.209 0 0 0 64.51 64.509V828h14.42v-14.783a72.209 72.209 0 0 0 64.51-64.509H1283v-14.416zm-79.29 64.382v-6.716h-14.42v6.716a57.729 57.729 0 0 1-49.96-49.966h6.71v-14.416h-6.71a57.726 57.726 0 0 1 49.96-49.959v6.709h14.42v-6.709a57.726 57.726 0 0 1 49.96 49.959h-6.71v14.416h6.71a57.729 57.729 0 0 1-49.96 49.966zm0-93.216h-14.42v7.575a18.02 18.02 0 0 0 3.61 35.675h7.2a3.6 3.6 0 1 1 0 7.209h-25.22v14.416h14.41v7.209h14.42v-7.575a18.019 18.019 0 0 0-3.61-35.675h-7.2a3.6 3.6 0 1 1 0-7.209h25.23v-14.416h-14.42v-7.209z" transform="translate(-1110 -655)"/>'
  }
})
